import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import config from '../../config';
import { Heart, Gear, LinkExternal, Logout, Edit } from '../icons';
import profileIcons from '../icons/profileIcons';

const AccountMenu = ({
  isAdmin = false,
  isStaff = false,
  profile = null,
  closeBurgerMenu,
  handleOpenProfileEditorModal,
  onChangeProfileClick,
  handleLogout
}) => {
  const closeMenu = () => closeBurgerMenu('accountOpen');

  return (
    <div className="header__account-menu">
      <div className="header-dropdown__account-greeting">
        {/* 1. Optional chaining and simplified icon logic */}
        {profile?.icon && profileIcons[profile.icon] ? (
          <img
            src={profileIcons[profile.icon]}
            width="72"
            height="72"
            className="header-dropdown__account-greeting-icon"
            alt={`${profile.firstName}'s avatar`}
          />
        ) : (
          <Heart
            width="7.2rem"
            height="7.2rem"
            className="header-dropdown__account-greeting-icon"
          />
        )}

        <button
          type="button"
          className="header-dropdown__account-edit-button"
          onClick={() => {
            closeMenu();
            handleOpenProfileEditorModal(profile?.id);
          }}
        >
          <Edit
            width="1.6rem"
            height="1.6rem"
            viewBox="0 0 32 32"
            className="header-dropdown__account-edit-icon"
          />
        </button>

        <div className="header-dropdown__account-greeting-content">
          {profile?.firstName && <h3>{profile.firstName}</h3>}
          
          {/* 2. Refactored from NavLink to button for semantic correctness */}
          <button
            type="button"
            className="header-dropdown__account-greeting-content-link btn-link"
            onClick={() => {
              onChangeProfileClick();
              closeMenu();
            }}
          >
            Change Profile
          </button>
        </div>
      </div>

      <NavLink
        to="/options"
        onClick={closeMenu}
        className={({ isActive }) => 
          `full-width-link header-menu-dropdown__link ${isActive ? '--active' : ''}`
        }
      >
        <div className="header-menu-dropdown__link-contents header-menu-dropdown__link-contents--settings">
          <Gear width="24" height="24" viewBox="0 0 32 32" />
          <span>Settings</span>
        </div>
      </NavLink>

      {/* 3. Consolidated Admin/Staff logic */}
      {(isAdmin || isStaff) && (
        <button
          type="button"
          className="full-width-link header-menu-dropdown__link"
          onClick={() => {
            window.open(config.adminURL, '_blank', 'noopener,noreferrer');
            closeMenu();
          }}
        >
          <div className="header-menu-dropdown__link-contents header-menu-dropdown__link-contents--admin-portal">
            <LinkExternal width="24" height="24" fill="white" viewBox="0 0 24 24" />
            <span>Admin Portal</span>
          </div>
        </button>
      )}

      <NavLink
        to="/"
        className="full-width-link header-menu-dropdown__link"
        onClick={handleLogout}
      >
        <div className="header-menu-dropdown__link-contents">
          <Logout width="24" height="24" fill="white" viewBox="0 0 32 32" />
          <span>Log Out</span>
        </div>
      </NavLink>
    </div>
  );
};

AccountMenu.propTypes = {
  isAdmin: PropTypes.bool,
  isStaff: PropTypes.bool,
  profile: PropTypes.shape({
    icon: PropTypes.string,
    id: PropTypes.string,
    firstName: PropTypes.string
  }),
  closeBurgerMenu: PropTypes.func.isRequired,
  handleOpenProfileEditorModal: PropTypes.func.isRequired,
  onChangeProfileClick: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired
};

export default AccountMenu;
